/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_VenueInputs */



/**
* | output |
* | --- |
* | "Venue" |
*
* @param {Tfield_VenueInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_venue = /** @type {((inputs?: Tfield_VenueInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_VenueInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lieu")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sede")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Local")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sede")
	return /** @type {LocalizedString} */ ("Venue")
});